// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1j_y3","cancel":"Button_cancel__3TW88","submit":"Button_submit__3QQZN"};